"use strict";

export default {
    state: {
        cartResource: {},
        cartId: 1,
        cart: {
            id: null,
            total: {
                amount: 0
            },
            items: [],
            payments: [],
            linked_backorder: false
        },
        selectedCartItems: [],
        maxOrderAmount: 30000
    },
    
    getters: {
        cartResource: state => {
            return state.cartResource;
        },
        
        currentCart: state => {
            return state.cart;
        },
        
        maxOrderAmount: state => {
            return state.maxOrderAmount;
        },
        
        selectedCartItems: state => {
            return state.selectedCartItems;
        },

        cartId: state => {
            return state.cartId;
        }
    },
    
    mutations: {
        setCart: ( state, cart ) => {
            state.cart = cart;
        },
        
        cartResource: ( state, cartResource ) => {
            state.cartResource = cartResource;
        },
        
        clearSelectedCartItems: ( state ) => {
            state.selectedCartItems = [];
        },

        setCartId: ( state, newId) => {
            state.cartId = newId;
        },
        
        addSelectedCartItem: ( state, itemId ) => {
            state.selectedCartItems.push( itemId );
        },
        
        removeSelectedCartItem: ( state, itemId ) => {
            state.selectedCartItems = state.selectedCartItems.filter( e => e !== itemId );
        },
        
        maxOrderAmount: ( state, amount ) => {
            state.maxOrderAmount = amount;
        }
    },
    
    actions: {
        addItemToCart( { commit, getters, dispatch }, itemData ) {
            let sales = getters.salesResource;
            return new Promise(
                ( resolve, reject ) => {
                    sales.addSalesOrderItem(
                        { salesId: getters.currentCart.id },
                        {
                            product_id: itemData.product_id,
                            cost: itemData.cost,
                            quantity: itemData.quantity,
                            order_type: 'App\\Grotec\\Models\\Sales\\Sales',
                            note: itemData.note
                        }
                    ).then(
                        ( cart ) => {
                            resolve( cart.data )
                        },
                        error => {
                            reject( 'Problem adding item to sales' );
                        }
                    );
                }
            );
        },
        
        updateCartItem( { commit, getters }, itemData ) {
            return new Promise( ( resolve, reject ) => {
                let salesResource = getters.salesResource;
                let currentCart = getters.currentCart;
                salesResource.updateSalesOrderItem(
                    {
                        salesId: currentCart.id,
                        itemId: itemData.id
                    },
                    {
                        product_id: itemData.product_id,
                        cost: itemData.item_cost,
                        quantity: itemData.quantity,
                        taken: itemData.taken,
                        note: itemData.note
                    }
                ).then(
                    ( cart ) => {
                        resolve( cart.data );
                    },
                    ( error ) => {
                        console.log( error );
                    }
                );
            } );
            
        },
        
        removeCartItem( { commit, getters }, itemData ) {
            let salesResource = getters.salesResource;
            let currentCart = getters.currentCart;
            
            salesResource.removeSalesOrderItem( { salesId: currentCart.id, itemId: itemData.id } )
                .then(
                    ( cart ) => {
                        //commit( 'setCart', cart.data );
                    },
                    ( error ) => {
                        console.log( error );
                    }
                )
        },
    }
};
